
/**
 * jquery validate オプション(rules,messages)　の設定
 * なんでも売却相談（簡易版）
 *   必須: 物件の種類 / 物件所在地(都県/市区町村/町名・字丁目・番地) / お名前 / ふりがな / 電話番号 / メールアドレス / ご相談内容
 *   ※ 郵便番号は任意（住所自動入力の補助。入力時のみ7桁フォーマットチェック）。
 */
(function () {

  // 変数
  var rul = {}; // ルール
  var msg = {}; // メッセージ

  // グローバル変数　※先に js/validation/common.js を読み込んでおく
  var getMsg = window.ohValidateGetMsg;       // メッセージリスト
  var changeBlank = window.ohValidateChangeBlank;     // 空白変換関数
  var changeHankaku = window.ohValidateChangehankaku; // 半角変換関数

  // 物件の種類 ※必須
  rul['valuation_property_type1'] = {
    range: [1, 3],
    required: {
      depends: function () {
        $(this).val(changeBlank($(this).val()));
        return true;
      }
    },
  };
  msg['valuation_property_type1'] = {
    range: getMsg('in'),
    required: getMsg('required', '物件の種類の選択'),
  };

  // 物件所在地：郵便番号 ※任意（入力時のみ数字7桁ちょうどのフォーマットチェック）
  rul['valuation_zip_cd'] = {
    required: {
      depends: function () {
        $(this).val($.trim($(this).val()));
        $(this).val(changeHankaku($(this).val()));
        return false;
      }
    },
    regex: '^[0-9]{7}$',
  };
  msg['valuation_zip_cd'] = {
    regex: getMsg('single_bite_number', '郵便番号', { 'digits': '7桁' }),
  };

  // 都県 ※必須
  rul['valuation_pref'] = {
    required: {
      depends: function (element) {
        $(this).val(changeBlank($(this).val()));
        return true;
      }
    },
  };
  msg['valuation_pref'] = {
    required: getMsg('required', '都県'),
  };

  // 市区町村 ※必須
  rul['valuation_city'] = {
    required: {
      depends: function (element) {
        $(this).val(changeBlank($(this).val()));
        return true;
      }
    },
  };
  msg['valuation_city'] = {
    required: getMsg('required', '市区町村'),
  };

  // 町名 ※必須
  rul['valuation_town'] = {
    required: {
      depends: function (element) {
        $(this).val(changeBlank($(this).val()));
        return true;
      }
    },
  };
  msg['valuation_town'] = {
    required: getMsg('required', '町名'),
  };

  // 字／丁目（選択肢が1件以上あるとき必須。0件時は common.js が disabled 化＝検証対象外）
  rul['valuation_address2_etc'] = {
    required: {
      depends: function (element) {
        var $el = $(this);
        return !$el.prop('disabled') && $el.find('option').length > 1;
      }
    },
    maxlength: 40
  };
  msg['valuation_address2_etc'] = {
    required: getMsg('required', '字/丁目'),
    maxlength: getMsg('max.string', '字/丁目', { 'max': '40' }),
  };

  // 番地（全物件種別で必須）
  rul['valuation_address2_banchi'] = {
    required: {
      depends: function () {
        $(this).val(changeBlank($(this).val()));
        return true;
      }
    },
    maxlength: 30
  };
  msg['valuation_address2_banchi'] = {
    required: getMsg('required', '番地'),
    maxlength: getMsg('max.string', '番地', { 'max': '30' }),
  };

  // マンション名（マンションのとき必須）
  rul['valuation_mansion_nm'] = {
    required: {
      depends: function () {
        $(this).val(changeBlank($(this).val()));
        return $('#valuation_property_type1_3').prop('checked');
      }
    },
    maxlength: 40
  };
  msg['valuation_mansion_nm'] = {
    required: getMsg('required', 'マンション名'),
    maxlength: getMsg('max.string', 'マンション名', { 'max': '40' }),
  };

  // 部屋番号（マンションのとき必須）
  rul['valuation_room_no'] = {
    required: {
      depends: function () {
        $(this).val(changeBlank($(this).val()));
        return $('#valuation_property_type1_3').prop('checked');
      }
    },
    maxlength: 5
  };
  msg['valuation_room_no'] = {
    required: getMsg('required', '部屋番号'),
    maxlength: getMsg('max.string', '部屋番号', { 'max': '5' }),
  };

  // お名前 ※必須
  rul['customer_nm'] = {
    required: {
      depends: function () {
        $(this).val(changeBlank($(this).val()));
        return true;
      }
    },
    maxlength: 40
  };
  msg['customer_nm'] = {
    required: getMsg('required', '名前'),
    maxlength: getMsg('max.string', '名前', { 'max': '40' }),
  };

  // ふりがな ※必須
  rul['customer_kn'] = {
    required: {
      depends: function () {
        $(this).val(changeBlank($(this).val()));
        return true;
      }
    },
    kana: true,
    maxlength: 40
  };
  msg['customer_kn'] = {
    required: getMsg('required', 'ふりがな'),
    kana: getMsg('kana2'),
    maxlength: getMsg('max.string', 'ふりがな', { 'max': '40' })
  };

  // 電話番号 ※必須（トリム,空白,半角に自動変換）
  rul['customer_mobile_no'] = {
    required: {
      depends: function () {
        $(this).val($.trim($(this).val()));
        $(this).val(changeBlank($(this).val()));
        $(this).val(changeHankaku($(this).val()));
        return true;
      }
    },
    regex: '^(0{1}\\d{1,4}-{0,1}\\d{1,4}-{0,1}\\d{1,4})$',
    maxlength: 13
  };
  msg['customer_mobile_no'] = {
    required: getMsg('required', '電話番号'),
    regex: getMsg('regex', '電話番号'),
    maxlength: getMsg('max.string', '電話番号', { 'max': '13' }),
  };

  // メールアドレス ※必須
  rul['customer_email'] = {
    required: true,
    maxlength: 60,
    url: false,
    remote: "/api/validate-email-dns",
  };
  msg['customer_email'] = {
    required: getMsg('required', 'E-mailアドレス'),
    maxlength: getMsg('max.string', 'E-mailアドレス', { 'max': '60' }),
    remote: getMsg('email_dns', 'E-mailアドレス'),
  };

  // ご相談内容 ※必須
  rul['customer_txt'] = {
    required: {
      depends: function () {
        $(this).val(changeBlank($(this).val()));
        return true;
      }
    },
    maxlength: 500
  };
  msg['customer_txt'] = {
    required: getMsg('required', 'ご相談内容'),
    maxlength: getMsg('max.string', 'ご相談内容', { 'max': '500' }),
  };

  // 個人情報保護方針（プライバシー・ポリシー）※hidden固定送信のため実質no-op
  rul['privacy_policy'] = { required: true };
  msg['privacy_policy'] = { required: getMsg('required', '個人情報保護方針（プライバシー・ポリシー）') };

  // グローバル変数に格納
  window.ohValidateRul = rul;
  window.ohValidateMsg = msg;
  window.ohValidateGlp = {};

}());
